<ng-content select="[pmd-card-avatar], [pmdCardAvatar]"></ng-content>
<ng-content
      select="pmd-card-title, pmd-card-subtitle,
      [pmd-card-title], [pmd-card-subtitle],
      [pmdCardTitle], [pmdCardSubtitle]"></ng-content>
<ng-content></ng-content>